import { render, staticRenderFns } from "./AddEditForm.vue?vue&type=template&id=63e6cfd4"
import script from "./AddEditForm.vue?vue&type=script&lang=js"
export * from "./AddEditForm.vue?vue&type=script&lang=js"
import style0 from "./AddEditForm.vue?vue&type=style&index=0&id=63e6cfd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports